/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basis-set': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M113.778 56.889V967.11h796.444V56.89zm113.778 170.667h398.222v113.777H227.556zm0 227.555h341.333V568.89H227.556zm568.888 341.333H227.556V682.667h568.888z" _fill="#cdcdcd"/>'
  }
})
